import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useCallback } from 'react';

export const useLogClickMore = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  return useCallback(
    (listId: string) => {
      logMarketAnalytics({
        name: 'CLICK_MORE',
        channel: ['ablylog'],
        analytics: {
          LIST_ID: listId,
        },
      });
    },
    [logMarketAnalytics],
  );
};
